// extracted by mini-css-extract-plugin
export default {"colorList":"SelectColor_colorList__xsY8e","colorItem":"SelectColor_colorItem__TFJUb","active":"SelectColor_active__bGsfc"};